export const language = "si";
export const properLanguage = "sl";

export const OFFERS_URL = "/najem-plovil";
export const WISHLIST_URL = "/seznam-zelja";
export const DESTINATIONS_URL = "/destinacije";
export const FAQ_URL = "/pogosta-vprasanja";
export const CONTACT_URL = "/kontakt";
export const PARTNERS_URL = "/za-partnerje";
export const INSURANCE_URL = "/zavarovanja";

export const DEFAULT_COUNTRY = 100144;
